
import { useState } from 'react';

const defaultFaqs = [
  {
    question: 'Who can become a Boggler guide?',
    answer: 'Guides can be life coaches, spiritual or religious devotees, retirees, elders, peer mentors, or digital friends who are steady, respectful, and genuinely willing to listen.'
  },
  {
    question: 'Is The Boggler donation based?',
    answer: 'Yes. The Boggler is donation-based and is focused on support rather than fixed-price pressure. However, it helps you ask! Connect your bank account via Stripe or Wise, send invoices, and get paid for your time and effort.'
  },
  {
    question: 'How do conversations work?',
    answer: "The Boggler helps make an introduction, and the conversation continues privately through WhatsApp. People can talk one-on-one about stories, questions, interests, and what life feels like where they are."
  },
  {
    question: 'What do people talk about?',
    answer: "Topics can include family, work, food, faith, grief, loneliness, love, life transitions, other countries, and personal hopes or worries. Guides are not expected to be therapists. They are expected to be thoughtful listeners and conversation partners."
  },
  {
    question: 'Is there a cost to join?',
    answer: "No. It is free to apply and become a Boggler guide."
  },
  {
    question: 'How long does the application process take?',
    answer: 'Applications are reviewed before guides are introduced to customers. Once approved, you can set up your profile, availability, and WhatsApp contact details.'
  },
  {
    question: 'Do guides need to be licensed mental health professionals?',
    answer: 'No. The Boggler is for peer connection, friendship, mentorship, spiritual conversation, and life guidance. It is not a replacement for crisis care, medical care, or licensed therapy.'
  },
  {
    question: 'What support do I get as a guide?',
    answer: "You can reach someone at The Boggler through WhatsApp at +1-949-370-2591 or email support@theboggler.com."
  }
];

export default function FAQ({ faqs: faqsProp }) {
  const faqs = faqsProp || defaultFaqs;
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-10 px-6 relative z-10">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-4xl md:text-5xl text-dark-teal text-center mb-4">
          Frequently Asked Questions
        </h2>
        <p className="text-xl text-secondary-text text-center mb-16 font-lato">
          Everything you need to know about guiding on The Boggler.
        </p>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-boggler shadow-card overflow-hidden transition-all duration-300 hover:shadow-boggler"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-6 text-left"
              >
                <h3 className="text-lg font-montserrat font-semibold text-heading-dark pr-4">{faq.question}</h3>
                <svg
                  className={`w-6 h-6 text-boggler-teal flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`}>
                <div className="px-6 pb-6 text-primary-text font-lato leading-relaxed">{faq.answer}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
